<template>
    <div class="home">
      <div class="service_box">
        <div class="banner">
          <swiper :options="swiperOption">
            <swiper-slide v-for="(slide, index) in swiperSlides" :key="index" :style="{'background': `url(${slide.imgUrl}) no-repeat center center`}">
              <a target="_blank" :href="slide.jumpUrl ? slide.jumpUrl : 'javascript:;'"></a>
            </swiper-slide>
            <div class="swiper-pagination" slot="pagination"></div>
          </swiper>
        </div>
        <div class="mid-width">
          <div class="service">
            <div class="list_title">
              <h1>业务范围</h1>
            </div>
            <ul class="service_list clearfix">
              <router-link class="border-div-1" to="/service" tag="li" v-for="item in lawyerProductList" :key="item.index">
                <div class="text_title">{{item.name}}</div>
                <p>{{item.describe? (item.describe.length > 85? item.describe.substring(0, 85)+'...' : item.describe) : ''}}</p>
                <div class="detail">查看详情</div>
              </router-link>
            </ul>
          </div>
          <div class="service-more ft15" @click="getServiceHome()">
              查看更多
          </div>
        </div>
      </div>
      <div class="team_box">
        <div class="team_bg">
          <div class="mid-width">
            <div class="text">
              <h2>关于律信</h2>
              <p>律信网，是依托上海市君志律师事务所罗贤德律师（合伙人）的团队资源，利用互联网技术为公众提供以法律服务为中心，同时涵盖公司治理、保险咨询、移民咨询等方面业务的综合性专业服务平台。</p>
              <p>律信人秉承“君子之合，信誉至上”、“客户利益为中心”两大原则，汇集了高层次的法律、移民、保险等相关领域的专业人才。以认真严谨的作风、秉持负责任的态度，为社会公众提供优质、高效的专业法律服务，是律信人一如既往的承诺。“诚信为本，理法为先”是我们的服务理念。</p>
              <p>律信，保障您的生活安康，助力您的事业腾飞！</p>
            </div>
          </div>
        </div>
      </div>

      <div class="news_box">
        <div class="news-warpper mid-width">
          <div class="title text-center">
              <P class="ft28 font-color-333">新闻资讯</P>
              <P class="ft15 font-color-999 margin-top20">新闻热点、行业资讯、最新政策，一应俱全</P>
          </div>
          <div class="news-list margin-top50 ft15">
              <div class="float-left news-col border-div-1" v-for="item in newsList" :key="item.index" @click="getNewDetail(item.id)">
                  <div class="img-col">
                      <img class="img_hover" :src="item.imageUrl" alt="" width="100%" height="100%">
                  </div>
                  <div class="title-col text-center">
                      <a href="">{{item.title? (item.title.length > 16? item.title.substring(0, 16)+'...' : item.title) : ''}}</a>
                  </div>
              </div>
          </div>
          <!-- <div class="news-more ft15" @click="getInfoHome()">
              查看更多
          </div> -->
        </div>
      </div>

      <div class="case_box">
        <div class="list_title">
          <h1>典型案例</h1>
          <div class="tips">帮助您解决实际问题，顺利、及时，是我们存在的根本价值</div>
        </div>
        <div class="case_list mid-width" v-for="item in caseList" :key="item.index" @click="getCaseDetail(item.id)">
          <div class="case_img">
            <img class="img_hover" :src="item.imageUrl" alt="" width="100%" height="100%">
          </div>
          <div class="case_content border-div-1">
            <div class="c_title">
              <a href="">{{item.title? (item.title.length > 50? item.title.substring(0, 50)+'...' : item.title) : ''}}</a>
            </div>
            <div class="c_desc">
              {{item.introduction? (item.introduction.length > 200? item.introduction.substring(0, 200)+'...' : item.introduction) : ''}}
            </div>
            <div class="c_date">{{item.createTime | timeFormat}}</div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import Api from '@/common/api/api'
import {timeFormat} from '@/common/js/dateTimeFormat.js'
export default {
    name: 'carrousel',
    data() {
      return {
        currentPage: 1,
        swiperOption: {
          pagination: {
            el: '.swiper-pagination',
            clickable :true
          },
          notNextTick: true,
          autoplay: true
        },
        swiperSlides: [],
        lawyerProductList: [],
        teamList: [],
        newsList: [],
        caseList: []
      }
    },
    created() {
      this.teamData()
      this.getLawyerProduct()
      this.getNewsList()
      this.getCaseList()
    },
    mounted() {
      this.getBanner()
    },
    methods: {
      getBanner() {
        Api.getBanner({
          page: this.currentPage,
          limit: 6
        }).then((response) => {
          if (response.data.code === 0) {
            this.swiperSlides = response.data.page.list
          }
        })
        .catch((error) => {
          console.log(error);
        })
      },
      getLawyerProduct() {
        Api.lawyerProduct({
          page: 1,
          limit: 4
        }).then((response) => {
          if (response.data.code === 0) {
            this.lawyerProductList = response.data.page.list
          }
        })
        .catch((error) => {
          console.log(error);
        });
      },
      teamData() {
        Api.lawyerTeam({
          page: 1,
          limit: 3
        }).then((response) => {
          console.log(response)
          if (response.data.code === 0) {
            this.teamList = response.data.page.list
          }
        })
        .catch((error) => {
          console.log(error);
        });
      },
      getTeam() {
        this.$router.push({
          path:'/team'
        })
      },
      getNewsList() {
        Api.getCmscontent({
          page: 1,
          limit: 3,
          subjectParentId: '2'
        }).then((response) => {
          if (response.data.code === 0) {
            this.newsList = response.data.page.list
          }
        })
        .catch((error) => {
          console.log(error);
        })
      },
      getNewDetail(e) {
          const {href} = this.$router.resolve({
              name:'newsDetail',
              query: {
                  id: e,
                  parentId: 2
              }
          })
          window.open(href,'_blank')
      },
      getInfoHome() {
          const {href} =this.$router.resolve({
              name: 'news',
          })
          window.open(href,'_blank')
      },
      getServiceHome() {
          const {href} =this.$router.resolve({
              name: 'service',
          })
          window.open(href,'_blank')
      },
      getCaseList() {
        Api.getCmscontent({
          page: 1,
          limit: 3,
          subjectParentId: '1'
        }).then((response) => {
          if (response.data.code === 0) {
            this.caseList = response.data.page.list
          }
        })
        .catch((error) => {
          console.log(error);
        })
      },
      getCaseDetail(e) {
          const {href} = this.$router.resolve({
              name:'newsDetail',
              query: {
                  id: e,
                  parentId: 1
              }
          })
          window.open(href,'_blank')
      },
    },
    components: {
      swiper,
      swiperSlide
    },
    filters: {
        timeFormat: function (time) {
            return timeFormat(time);
        }
    }
  }
</script>

<style lang="scss" scoped>
  @import '~@/common/css/common';
  .marginBottom75 {
    margin-bottom: 75px;
  }
  /*鼠标移至图标，缓慢放大*/
  .img_hover {
      transition: all 0.7s;
      &:hover {
          transform: scale(1.1); //rotate(10deg)旋转角度设置
          transition-duration: 0.7s;
      }
  }
  .home {
    background: rgba(245, 245, 245, 1);
    .list_title {
      font-size: 28px;
      color: #333;
      padding: 60px 0;
      text-align: center;
      .tips {
        font-size: 15px;
        color: #aeaeae;
        margin-top: 15px;
      }
    }
    .service_box {
      padding-bottom: 75px;
      .banner {
        height: 420px;
        .swiper-container {
          height: 420px;
          background-position: center center;
          a{
            display: block;
            width: 100%;
            height: 100%;
          }
        }
      }
    }
    .service_list {
      li {
        position: relative;
        float: left;
        width: 280px;
        height: 410px;
        padding: 25px 25px 75px;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
        background: #fff;
        font-size: 15px;
        color: #666;
        margin-right: 25px;
        cursor: pointer;
        .text_title {
          font-size: 18px;
          color: #333;
          text-align: center;
          height: 32px;
          border-bottom: 1px solid #d6d7d8;
          margin-bottom: 30px;
        }
        p {
          line-height: 38px;
        }
        .detail {
          display: block;
          position: absolute;
          bottom: 0;
          height: 50px;
          line-height: 50px;
          text-align: center;
          background: #54a0fe;
          color: #fff;
          font-weight: bold;
          width: 280px;
          left: 0;
        }
        .price {
          display: none;
          position: absolute;
          bottom: 0;
          height: 50px;
          line-height: 50px;
          text-align: center;
          background: #54a0fe;
          color: #fff;
          font-weight: bold;
          width: 280px;
          left: 0;
        }
        &:hover {
          .price {
            display: block;
          }
        }
      }
      li:last-child {
        margin-right: 0;
      }
    }
    .service-more {
            margin: 50px auto -25px auto;
            width: 150px;
            height: 45px;
            line-height: 45px;
            text-align: center;
            color: #20A0FE;
            border: 1px solid #20A0FE;
            background-color: #fff;
            cursor: pointer;
        }
    .team_box {
      background: #fff;
      //padding-bottom: 75px;
      .team_bg {
        height: 365px;
        width: 100%;
        background: url("./img0.jpg") no-repeat center;
        background-size: cover;
        box-sizing: border-box;
        .text {
          width: 600px;
          padding: 20px 0;
          color: #c9c9c9;
          font-size: 15px;
          line-height: 28px;
          h2 {
            font-size: 28px;
            font-weight: 400;
            text-align: center;
          }
          p {
            text-indent: 2em;
            font-size: 15px;
            margin-top: 20px;
          }
        }
      }
    }
    .team {
      font-size: 15px;
      color: #333;
      text-align: center;
      li {
        float: left;
        width: 305px;
        cursor: pointer;
        img{
          width: 305px;
          height: 305px;
          margin-bottom: 25px;
        }
      }
      li:nth-child(1) {
        margin-left: 102px;
      }
      li:nth-child(2) {
        margin: 0 35px;
      }
    }
    .case_box {
      padding-bottom: 75px;
      text-align: center;
      .case_list {
        margin-bottom: 30px;
        height: 250px;
        cursor: pointer;
        .case_img {
          width: 380px;
          height: 250px;
          float: left;
          margin-right: 30px;
          overflow: hidden;
        }
        .case_content {
          background-color: #fff;
          float: left;
          width: 790px;
          height: 250px;
          text-align: left;
          padding: 5px 10px;
          .c_title {
            width: 100%;
            height: 50px;
            line-height: 50px;
            font-size: 18px;
          }
          .c_desc {
            width: 100%;
            height: 150px;
            line-height: 32px;
            font-size: 15px;
            color: #999999;
          }
          .c_date {
            width: 100%;
            height: 50px;
            line-height: 50px;
            font-size: 15px;
            color: #999999;
            text-align: left;
          }
        }
      }
    }
    .news_box {
      //margin-top: 50px;
      padding-top: 50px;
      height: 420px;
      //background-color: #f1f1f5;
      .news-warpper {
        .news-list {
            height: 170px;
            .news-col {
                width: 380px;
                height: 230px;
                background-color: #fff;
                //overflow: hidden;
                margin-right: 30px;
                &:last-child {margin-right: 0;}
                cursor: pointer;
                .img-col {
                    height: 170px;
                    overflow: hidden;
                }
                .title-col {
                    height: 60px;
                    line-height: 60px;
                }
                /*transition: all 1s;
                &:hover {
                    //box-shadow: -2px 1px 1px 1px rgba(201, 201, 201, 0.349019607843137); //边框阴影效果
                    transform: scale(1.02);
                    transition-duration: 1s;
                    box-shadow: 0 0 1px #c5d8db;
                } */

            }

        }
        // .news-more {
        //     margin: 50px auto;
        //     width: 150px;
        //     height: 45px;
        //     line-height: 45px;
        //     text-align: center;
        //     color: #20A0FE;
        //     border: 1px solid #20A0FE;
        //     background-color: #fff;
        //     cursor: pointer;
        // }

      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/home/home.vue